[<template>
  <div>
    <v-container fluid pa-0>
      <v-layout wrap row justify-center>
        <v-flex xs12 pa-0>
          <v-card flat tile>
            <v-toolbar
              dark
              card
              dense
              color="theme_primary_lighten1"
              class="bordered white--text"
              align-center
              height="36"
            >
              <v-icon small pa-0 color="white">edit</v-icon>
              <v-toolbar-title style="margin-left: 8px;">
                <h6>Subsidiary settings</h6>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-switch
                id="is_a_subsidiary_switch"
                hide-details
                class="text-xs-center"
                style="flex: none;"
                :label="`${newCompany.name} is a Subsidiary`"
                @change="
                  updateModel(
                    'companyStore',
                    'newCompany',
                    'isSubsidiary',
                    !newCompany.isSubsidiary
                  )
                "
                :input-value="newCompany.isSubsidiary"
              />
            </v-toolbar>

            <v-layout
              v-show="newCompany.isSubsidiary"
              wrap
              justify-center
              row
              fill-height
              pa-4
            >
              <v-flex xs9 md4 pa-2>
                <uploader
                  id="subsidiary_actual_stamp"
                  name="exp-12"
                  v-on:s3url="
                    updateModel(
                      'companyStore',
                      ['newCompany', 'subsidiary'],
                      'actual_stamp',
                      $event
                    )
                  "
                />
                <v-text-field
                  label="Actual stamp"
                  disabled
                  :value="newCompany.subsidiary.actual_stamp"
                  background-color="#F4F4F5"
                  box
                />
              </v-flex>

              <v-flex xs9 md4 pa-2>
                <uploader
                  id="stamp_without_signature"
                  name="exp-12"
                  v-on:s3url="
                    updateModel(
                      'companyStore',
                      ['newCompany', 'subsidiary'],
                      'stamp_without_signature',
                      $event
                    )
                  "
                />
                <v-text-field
                  label="Stamp without signature"
                  disabled
                  :value="newCompany.subsidiary.stamp_without_signature"
                  background-color="#F4F4F5"
                  box
                />
              </v-flex>

              <v-flex xs9 md4 pa-2>
                <uploader
                  id="subsidiary_digital_signature"
                  name="exp-12"
                  v-on:s3url="
                    updateModel(
                      'companyStore',
                      ['newCompany', 'subsidiary'],
                      'digital_signature',
                      $event
                    )
                  "
                />
                <v-text-field
                  label="Digital Signature"
                  disabled
                  :value="newCompany.subsidiary.digital_signature"
                  background-color="#F4F4F5"
                  box
                />
              </v-flex>
            </v-layout>

            <v-layout
              px-4
              justify-center
              v-if="newCompany.isSubsidiary && !newCompany.subsidiary.id"
            >
              <v-alert style="width: 100%;" :value="true" type="info"
                >Save to access bank informations</v-alert
              >
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 px-4 pt-0>
          <v-container fluid pa-0>
            <v-layout wrap row>
              <v-layout xs12 pa-0 justify-center>
                <v-flex xs12 pa-0>
                  <collection
                    v-if="newCompany.id"
                    v-show="newCompany.isSubsidiary && newCompany.subsidiary.id"
                    formComponent="bankInformationForm"
                    resourceName="bank_informations"
                    store="companyStore"
                    :collectionHeaders="{
                      name: 'String',
                      beneficiary_bank: 'String',
                      currency: 'commonResource',
                      account_name: 'String',
                    }"
                  />
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import collection from "../shared/collection";
import uploader from "../../components/shared/uploader";

export default {
  components: {
    uploader,
    collection,
  },
  computed: {
    ...mapGetters("companyStore", ["newCompany"]),
  },
};
</script>
